module.exports = __webpack_public_path__ + "img/quite1.0.1.fb31897b.gif";